import { bindAll } from 'shared/decorators/bindAll';
import {createNotificationBar} from '../../components/notification-bar/create-notification-bar';

const VALID_STATES = ['information', 'success', 'done', 'warning', 'error'];

/**
 * This class allows users to popup dismissible notifications on the uScope UI
 */
@bindAll
export class NotificationService {
  constructor (container) {
    this.container = container;

    VALID_STATES.forEach((state) => {
      this[state] = (message, duration) => this.show(state, message, duration);
    });
  }

  show (type, message, duration = 5000) {
    this.clear(); // Remove UI elements that we're about to hide
    this.ui = createNotificationBar(type, message);
    this.container.appendChild(this.ui.container);
    this.ui.show();

    if (duration > 0) {
      setTimeout(this.hide, duration);
    }
  }

  hide () {
    if (this.ui) {
      this.ui.hide();
      delete this.ui;
    }
  }

  clear () {
    if (this.ui) {
      this.ui.remove();
      delete this.ui;
    }
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/lib/services/notification-service.js